<template>
  <label class="works-filter__labels">
    <span class="checkbox">
      <input type="checkbox" v-model="annotation" name="annotation"/>
      <span class="check"/>
    </span>
    {{ annotationLabel }}
  </label>
</template>

<script>
  import FilterAnnotationMix from "../../../../../components/list/filter/FilterAnnotationMix";

  export default {
    name   : 'filter-annotation-sub',
    mixins: [FilterAnnotationMix],

    data() {
      return {
        annotationLabel: this.$t("message.WithAnnotationSub")
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/sub/flat_light/components/list/filter/FilterAnnotationSub.vue